import {ColumnMain} from "#/models/column-main";
import {Column} from "#/models/column";
import {Trans} from "@lingui/macro";
import {Tag} from "antd";
import React from "react";

const DdsAssignmentRuleModel = () : ColumnMain => {

    const columns : Array<Column> = new Array();

    columns.push({key:'ddsNumber', width: 300, sorter:true,title:<Trans>DDS Number</Trans>});
    columns.push({key:'item.itemNo', dataIndex: ['item', 'itemNo'], width: 150, sorter:true,title:<Trans>MSC Part Number</Trans>});
    columns.push({key:'quantity', width: 150, sorter:true,title:<Trans>Quantity</Trans>});
    columns.push({key:'validFrom', width: 150, dateFilter:true, sorter:true,title:<Trans>Valid From</Trans>});
    columns.push({key:'validTo', width: 150, dateFilter:true, sorter:true,title:<Trans>Valid To</Trans>});

    columns.push({key:'updatedDate', width: 150, dateTimeFilter:true, sorter:true,title:<Trans>Updated Date</Trans>});
    columns.push({key:'updatedBy', width: 200, sorter:true,title:<Trans>Updated By</Trans>});
    columns.push({key:'createdDate', width: 150, dateTimeFilter:true, sorter:true,title:<Trans>Created Date</Trans>,direction:"desc"});
    columns.push({key:'createdBy', width: 200, sorter:true,title:<Trans>Created By</Trans>});

    return{
        columns:columns,
        url:"/resource/dds-assignment-rules"
    };
}
export default DdsAssignmentRuleModel();
